import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import _ from 'lodash';

// Bootstrap Vue
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue);

// Custom plugin for global functions
import CustomFunctions from './plugins/custom-functions'
Vue.use(CustomFunctions);

// Circular Progress
import VueEllipseProgress from 'vue-ellipse-progress';
Vue.use(VueEllipseProgress);

// Quill Editor
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor, {
  modules: {
    toolbar: [
      [{ 'header': [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': [] }, 'clean'],
      ['link', 'image'],
    ],
  }
})

// Websockets
import Echo from 'laravel-echo';
window.Pusher = require('pusher-js');

// Import SASS file
import './assets/scss/app.scss'

// Font Awesome
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons' // TODO: sélectionner uniquement les icones utilisées
import { fad } from '@fortawesome/pro-duotone-svg-icons' // TODO: sélectionner uniquement les icones utilisées
import { fal } from '@fortawesome/pro-light-svg-icons' // TODO: sélectionner uniquement les icones utilisées
import { fas } from '@fortawesome/pro-solid-svg-icons' // TODO: sélectionner uniquement les icones utilisées
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons'
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)
library.add(fab)
library.add(fad)
library.add(fal)
library.add(fas)
library.add(faExclamationTriangle)

// custom global components
import BwMultiselect from "./components/global/BwMultiselect.vue";
Vue.component('bw-multiselect', BwMultiselect)
import BwWysiwyg from "./components/global/BwWysiwyg.vue";
Vue.component('bw-wysiwyg', BwWysiwyg)
import IconAndTitle from "./components/global/IconAndTitle.vue";
Vue.component('icon-and-title', IconAndTitle)
import IconAutofilled from "./components/global/icon/Autofilled.vue";
Vue.component('icon-autofilled', IconAutofilled)
import IconNotUpdatableAfterCreation from "./components/global/icon/NotUpdatableAfterCreation.vue";
Vue.component('icon-not-updatable-after-creation', IconNotUpdatableAfterCreation)
import IconRequired from "./components/global/icon/Required.vue";
Vue.component('icon-required', IconRequired)
import IconTranslatable from "./components/global/icon/Translatable.vue";
Vue.component('icon-translatable', IconTranslatable)

// vue-json-excel
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  created() {
    // let pusher_key = localStorage.getItem('pusher_key');

    // if (pusher_key !== null) {
    //   this.launchWebSockets(pusher_key);
    // } else {
    //   this.$store
    //     .dispatch("layout/getInitInfos")
    //     .then((data) => {
    //       localStorage.setItem('pusher_key', data.pusher_key)
    //       this.launchWebSockets(data.pusher_key)
    //     });
    // }
  },
  methods: {
    launchWebSockets(pusher_key) {
      console.log('---- launchWebSockets ----')
      // let api_url = new URL(window.location.protocol + '//' + window.location.hostname)
      window.Echo = new Echo({
        broadcaster: 'pusher',
        key: pusher_key,
        // wsHost: api_url.hostname,
        wsHost: window.location.hostname,
        wsPort: 6001,
        // wsPort: 3030,
        forceTLS: false,
        disableStats: true,
        enabledTransports: ['ws', 'wss'],
      });
    }
  },
  render: h => h(App)
}).$mount('#app')

// Custom mixins
Vue.mixin({
  methods: {
    isEmpty: obj => [Object, Array].includes((obj || {}).constructor) && !Object.entries((obj || {})).length,

    // format numbers with decimals
    number_format: function (number, decimals = this.$store.state.layout.settings.GLOBAL__AMOUNT_DECIMAL_NUMBER) {
      // use 2 times round() to avoid float accuracy hazard
      // Example:
      // in real life, 1.07950 x 50 = 53.975
      // with float, 1.07950 x 50 = 53.974999999999994
      // when we round with 2 décimal in real life => 53.98 but with float => 53.97
      let fixedFloat = _.round(Number.parseFloat(number), 6);
      return _.round(fixedFloat, decimals)
    },
    // format numbers into money
    money_format: function (number, currency = this.$store.state.layout.current_currency.code) {
      if (currency === '') {
        currency = this.$store.state.layout.current_currency.code
      }

      if (currency === '') {
        currency = this.$store.state.layout.default_currency.code
      }

      let options = {
        style: 'currency',
        currency: currency,
      };

      return new Intl.NumberFormat(this.$store.state.layout.current_language.code + "-" + this.$store.state.layout.current_language.country_code, options).format(Number.parseFloat(number));
    },
    calc_inctax(price, rate) {
      return price * (1 + rate / 100);
    },
    calc_exctax(price, rate) {
      return price / (1 + rate / 100);
    },
    format_bytes(a, b) { if (0 == a) return '0' + this.$t('global.filesize.B'); var c = 1024, d = b || 2, e = [this.$t('global.filesize.B'), this.$t('global.filesize.KB'), this.$t('global.filesize.MB'), this.$t('global.filesize.GB'), this.$t('global.filesize.TB'), this.$t('global.filesize.PB'), this.$t('global.filesize.EB'), this.$t('global.filesize.ZB'), this.$t('global.filesize.YB')], f = Math.floor(Math.log(a) / Math.log(c)); return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f] },
    // toasts
    toast_notification(content, title = null, variant = 'info', auto_hide = false) {
      this.$root.$bvToast.toast(content, {
        title: title ? title : this.$t('notification.model'),
        variant: variant,
        noAutoHide: !auto_hide,
      });
    },
    toast_success(content, title = null, params = {}) {
      let auto_hide = params.hasOwnProperty('auto_hide') ? params.auto_hide : true;

      this.$root.$bvToast.toast(content, {
        title: title,
        variant: 'success',
        noAutoHide: !auto_hide,
      });
    },
    toast_error(content = null, title = null, code = null, params = {}) {
      let toast_href = params.hasOwnProperty('toast_href') ? params.toast_href : null;
      let toast_to = params.hasOwnProperty('toast_to') ? params.toast_to : null;
      let auto_hide = params.hasOwnProperty('auto_hide') ? params.auto_hide : true;
      let close_button = params.hasOwnProperty('close_button') ? params.close_button : true;
      let id = params.hasOwnProperty('id') ? params.id : null;

      if (content === null) {
        switch (code) {
          case 401:
            this.$store.dispatch("user/reinitLayout");

            title = this.$t('error.401.title');
            content = this.$t('error.401.description') + ' ' + this.$t('error.401.link_text');
            toast_href = '/bwapp/login?redirect=' + this.$router.currentRoute.fullPath;
            auto_hide = false;
            close_button = false;
            break;
          case 403:
            title = this.$t('error.403.title');
            content = this.$t('error.403.description');
            break;
          case 404:
            content = this.$t('error.404.description');
            break;
          case 422:
            title = this.$t("error.form_errors.title");
            content = this.$t("error.form_errors");
            break;
          case 498:
            content = this.$t('error.498.description');
            break;
          case 500:
            content = this.$t('error.500.description');
            break;
          case 502:
            content = this.$t('error.502.description');
            break;
          case 503:
            content = this.$t('error.503.description');
            break;
          default:
            content = this.$t("error.impossible_action");
            break;
        }
      }

      this.$root.$bvToast.toast(content, {
        id: id,
        href: toast_href,
        to: toast_to,
        title: title ? title : this.$t("error.impossible_action.title", {
          code: code,
        }),
        variant: 'danger',
        noAutoHide: !auto_hide,
        noCloseButton: !close_button,
      });
    },
    catch_failure(failure) {
      this.toast_error(null, null, failure.status)
    },
    msg_box_ok(content = null, title = null) {
      this.$root.$bvModal
        .msgBoxOk(content ? content : this.$t("error.impossible_action"), {
          title: title ? title : this.$t("error.form_errors.title"),
          size: "sm",
          okVariant: "warning",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true,
        });
    },
    msg_box_confirm(content = null, title = null, callback) {
      this.$root.$bvModal
        .msgBoxConfirm(content ? content : this.$t("global.info.confirmation_request"), {
          title: title ? title : this.$t("global.title.confirmation_request"),
          okTitle: this.$t("global.action.confirm"),
          cancelTitle: this.$t("global.action.cancel"),
          centered: true,
        })
        .then(value => {
          callback(value);
        })
        .catch(err => {
        });
    },
  }
})
